import axios from 'axios'

export function uploadFile(file) {
  const fd = new FormData()
  fd.append('file', file)
  return axios.post('/xwzx/common/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  }).then((res) => {
    const data = res && res.data ? res.data : res
    if (!data || (data.code && data.code !== 200)) {
      return Promise.reject(new Error((data && data.msg) || '上传失败'))
    }
    return data
  })
}

export function filePreview(fileName) {
  if (!fileName) return ''
  const name = String(fileName)
  if (/^https?:\/\//i.test(name) || name.indexOf('blob:') === 0 || name.indexOf('data:') === 0) {
    return name
  }
  if (name.charAt(0) === '/') return '/xwzx' + name
  return '/xwzx/' + name
}
